import type {NavigationGuardReturn} from 'vue-router';
import type {FeatureFlagState} from '../../stores/featureFlagStore';
import type {Ref} from 'vue';

export async function handleFeatureFlagGuard(
    featureFlag: Ref<FeatureFlagState>
): Promise<NavigationGuardReturn> {
    try {
        // Wait for feature flag to be ready
        const isReady = await featureFlag.value.isReady();

        if (!isReady || featureFlag.value.availableInLicenseTiers) {
            return {name: 'AdminDashboard'};
        }

        // All checks passed, allow navigation
        return true;
    } catch {
        return {name: 'AdminDashboard'};
    }
}
